import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStorageService } from '@core/services/auth-storage.service';
import { PostLoginRedirectService } from '@core/services/post-login-redirect.service';
import { isTokenExpired } from '@shared/helpers/is-token-expired';

/**
 * Route guard that checks if the user is already authenticated with a valid token.
 * If authenticated, redirects to a default authenticated route (dashboard).
 * Used to prevent access to login/register pages for authenticated users.
 *
 * Usage in routes: canActivate: [AuthRedirectGuard]
 */
export const AuthRedirectGuard: CanActivateFn = route => {
  const authStorageService = inject(AuthStorageService);
  const router = inject(Router);
  const postLoginRedirectService = inject(PostLoginRedirectService);

  const authData = authStorageService.getAuthData();

  if (authData && !isTokenExpired(new Date(authData.expiresAt))) {
    const redirectUrl = postLoginRedirectService.consumeRedirectUrl(
      route.queryParamMap.get(postLoginRedirectService.queryParamName)
    );

    return router.parseUrl(redirectUrl ?? '/painel-frotista');
  }

  return true;
};
